var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoltSlash = function SvgBoltSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.753 10.454 2.39-2.482 3.329 3.329H3.113a.5.5 0 0 1-.36-.847ZM11.739 1.123 7.919 5.09l2.357 2.357 2.289-5.793c.201-.509-.445-.925-.825-.531ZM16.824 8.301h-5.695l3.604 3.604 2.464-2.772a.5.5 0 0 0-.374-.832ZM8.282 19.163l3.789-4.263-2.235-2.235-2.392 5.98c-.208.52.466.937.838.518ZM3.707 2.293a.999.999 0 1 0-1.414 1.414l14 14a.999.999 0 1 0 1.414-1.414l-14-14Z"
  })));
};
export default SvgBoltSlash;